import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, createVNode as _createVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-562bf7f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" ... ")
const _hoisted_2 = [
  _hoisted_1
]

import { nextTick, onMounted, ref, watch } from 'vue';
import { useRefElementWidth } from '@/hooks/use-ref-element-width';
import { useMutationObserver } from '@/hooks/use-mutation-observer';
import Tooltip from '@ui-kit/tooltip/Tooltip.vue';
import { popperTooltip } from '@/helpers/popper';
import { outsideClick as vOutsideClick, OutsideClickConfig } from '@/directives/outside-click';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowMoreLine',
  setup(__props) {

const wrapperRef = ref<HTMLElement|undefined>();
const contentRef = ref<HTMLElement|undefined>();
const width = useRefElementWidth(wrapperRef);
const showMore = ref<boolean>(false);
const active = ref<boolean>(false);
const tooltipRef = ref<InstanceType<typeof Tooltip>|undefined>(undefined);
const markRef = ref<HTMLElement|undefined>(undefined);

const outsideClickConfig = ref<OutsideClickConfig>({
  handler(){
    active.value = false;
  },
  additionalElements(){
    const tooltip = tooltipRef.value;
    return tooltip ? [tooltip.$el] : [];
  }
})
function clickHandler() {
  if (active.value) {
    active.value = false;
  } else {
    active.value = true;
    nextTick(() => {
      const mark = markRef.value;
      const tooltip = tooltipRef.value;

      if (mark && tooltip) {
        popperTooltip(mark, tooltip.$el, 'top');
      }
    })
  }
}

function recalculate() {
  showMore.value = false;
  nextTick(() => {
    const content = contentRef.value;
    if (content) {
      const scrollWidth = content.scrollWidth;
      if (scrollWidth > Math.round(width.value)) {
        showMore.value = true;
      }
    }
  });
}

useMutationObserver({
  target: contentRef,
  callback: recalculate,
});
watch(width, () => {
  recalculate();
})
onMounted(recalculate);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["show-more-wrapper", {'show-more-visible': showMore.value}]),
    ref_key: "wrapperRef",
    ref: wrapperRef
  }, [
    _createElementVNode("div", {
      class: "content",
      ref_key: "contentRef",
      ref: contentRef
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 512),
    (showMore.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "markRef",
          ref: markRef,
          class: _normalizeClass(["show-more", { active: active.value }]),
          onClick: clickHandler
        }, _hoisted_2, 2)), [
          [
            _unref(vOutsideClick),
            outsideClickConfig.value,
            void 0,
            { immediate: true }
          ]
        ])
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (active.value)
            ? (_openBlock(), _createBlock(Tooltip, {
                key: 0,
                ref_key: "tooltipRef",
                ref: tooltipRef,
                light: ""
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
              }, 512))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]))
  ], 2))
}
}

})